import { render, staticRenderFns } from "./BookingScheduleInfo.vue?vue&type=template&id=0740e512&scoped=true"
import script from "./BookingScheduleInfo.vue?vue&type=script&lang=js"
export * from "./BookingScheduleInfo.vue?vue&type=script&lang=js"
import style0 from "./BookingScheduleInfo.vue?vue&type=style&index=0&id=0740e512&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0740e512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0740e512')) {
      api.createRecord('0740e512', component.options)
    } else {
      api.reload('0740e512', component.options)
    }
    module.hot.accept("./BookingScheduleInfo.vue?vue&type=template&id=0740e512&scoped=true", function () {
      api.rerender('0740e512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/BookingScheduleInfo.vue"
export default component.exports